import {Action, Dispatch, MiddlewareAPI} from 'redux';

import {setErrorMessage} from 'containers/ErrorPage/actions';
import i18n from 'i18next';

const displayError =
  ({dispatch}: MiddlewareAPI) =>
  (next: Dispatch) =>
  (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: {payload: any} & Action
  ) => {
    const {type, payload: {error = undefined} = {}} = action;

    if (!type || !error) {
      return next(action);
    }

    if (error.silent) {
      console.log('Silent error', error.message);
      return next(action);
    }

    if (type.endsWith('_FAILURE')) {
      if (error && error.status === 401) {
        error.setMessage(i18n.t('errors.errorLoginAgain'));
      } else if (error.status && (error.status < 400 || error.status > 500)) {
        error.setMessage(i18n.t('errors.errorTryAgain'));
      }

      dispatch(setErrorMessage(error));
    }

    return next(action);
  };

export default displayError;
